import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ServiceBase {
  protected httpOptions = {
    headers: new HttpHeaders({
    'Content-Type': 'application/json',
    observe: 'response'
    }),
  };
  protected httpFormDataOptions = {
    headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded ',
    }),
  };

  protected httpCookieOptions = {
    headers: new HttpHeaders({
    'Content-Type': 'application/json',
    observe: 'response',

    }),
  };

  protected httpFileDataOptions = {
    headers: new HttpHeaders().append('Content-Disposition', 'multipart/form-data')
  };
  protected apiBaseUrl: string = `${environment.APIPath}`;
  protected apiCodeUrl: string = `${environment.CodeUrl}`;
  constructor(protected http: HttpClient) { }

  download<T>(paramUrl: string, paramBody: object, paramOption?: object): Observable<T> {
    let option = { responseType: "blob" as "json" };
    return this.http.post<T>(paramUrl, paramBody, option);
  }
}
